import { SVGProps } from 'react';

const SvgPallete2 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 33 32" {...props}>
    <path
      stroke="#2196F3"
      strokeWidth={2}
      d="M3 16.036c0 6.862 5.156 12.516 11.796 13.28.98.113 1.93-.304 2.627-1.004a2.24 2.24 0 0 0 0-3.163c-.698-.7-1.266-1.742-.74-2.579 2.102-3.343 12.984 4.335 12.984-6.534 0-7.383-5.97-13.368-13.334-13.368S3 8.653 3 16.036Z"
    />
    <path stroke="#2196F3" strokeWidth={2} d="M24.667 15.332a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" />
    <path fill="#2196F3" stroke="#2196F3" strokeWidth={2} d="M10 15.332a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" />
    <path
      stroke="#2196F3"
      strokeWidth={2}
      d="M14.113 9.332a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM20.667 9.332a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    />
  </svg>
);
export default SvgPallete2;
